import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    background: {
      default: '#EFEFEF',
    },
    primary: {
      main: '#01A63B',
    },
    text: {
      primary: '#363636',
      secondary: '#666666',
    },
  },
})
